import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { parseHtml } from '@grandvisionhq/utils';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import { getConsents } from '../../../selectors.js';
import { setConsents, toggleConsent } from '../../../StepShipping/actions.js';
import { ItemList } from '../components/ItemList.js';

const ConsentsContainer = ()=>{
    const dispatch = useDispatch();
    const { consent: consentSettings  } = useCheckoutSettings();
    const consents = useSelector(getConsents);
    React.useEffect(()=>{
        const checkoutConsents = (consentSettings === null || consentSettings === void 0 ? void 0 : consentSettings.items) || [];
        if (checkoutConsents.length !== (consents === null || consents === void 0 ? void 0 : consents.length)) {
            const initialConsents = checkoutConsents.map((consent)=>swcHelpers.objectSpread({}, consent, {
                    isChecked: false
                })
            );
            dispatch(setConsents({
                consents: initialConsents
            }));
        }
    }, [
        consentSettings,
        consents,
        dispatch
    ]);
    const handleChange = React.useCallback((selectedConsents)=>dispatch(toggleConsent({
            consents: selectedConsents.map((c)=>c.value
            )
        }))
    , [
        dispatch
    ]);
    const selectedConsents1 = React.useMemo(()=>{
        return (consents === null || consents === void 0 ? void 0 : consents.filter((consent)=>consent.isChecked
        )) || [];
    }, [
        consents
    ]);
    const getItemLabel = React.useCallback((item)=>parseHtml(item.title)
    , []);
    const getItemIdentifier = React.useCallback((item)=>item.value
    , []);
    const getItemErrorMessage = React.useCallback((item)=>{
        return (item === null || item === void 0 ? void 0 : item.errorMessage) || '';
    }, []);
    const shouldItemValidate = React.useCallback((item)=>{
        return (item === null || item === void 0 ? void 0 : item.shouldValidate) || false;
    }, []);
    if (!(consents === null || consents === void 0 ? void 0 : consents.length)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ItemList, {
        getItemIdentifier: getItemIdentifier,
        getItemLabel: getItemLabel,
        getItemErrorMessage: getItemErrorMessage,
        shouldItemValidate: shouldItemValidate,
        idPrefix: "consents__",
        items: consents,
        onChange: handleChange,
        selectedItems: selectedConsents1
    });
};

export { ConsentsContainer };
//# sourceMappingURL=ConsentsContainer.js.map
